/* This file was generated automatically. Do not edit manually. */

export enum SmsUsaRegistrationStatus {
    BrandRegistrationNone = 'BrandRegistrationNone',
    BrandRegistrationPending = 'BrandRegistrationPending',
    BrandRegistrationInReview = 'BrandRegistrationInReview',
    BrandRegistrationApproved = 'BrandRegistrationApproved',
    BrandRegistrationFailed = 'BrandRegistrationFailed',
    BrandRegistrationSuspended = 'BrandRegistrationSuspended',
    CampaignRegistrationPending = 'CampaignRegistrationPending',
    CampaignRegistrationInProgress = 'CampaignRegistrationInProgress',
    CampaignRegistrationFailed = 'CampaignRegistrationFailed',
    CampaignRegistrationVerified = 'CampaignRegistrationVerified',
    CampaignRegistrationSuspended = 'CampaignRegistrationSuspended',
}
